<div class="manage-orders">
  <h2>Manage Orders</h2>

  <!-- Loading and error -->
  <div *ngIf="loading" class="loading">Loading orders...</div>
  <div *ngIf="error" class="error">{{ error }}</div>

  <!-- Only render table when data is available -->
  <div *ngIf="!loading && orders">
    <!-- Optional customer summary (only when viewing a single customer's orders) -->
    <div *ngIf="!showAllOrders" class="customer-summary">
      <p><strong>Customer Name:</strong> <span class="info-text"> {{ orders.customer_name }}</span></p>
      <p><strong>Email:</strong> <span class="info-text"> {{ orders.customer_email }}</span></p>
      <p><strong>Customer ID:</strong> <span class="info-text"> {{ orders.customer_id }}</span></p>
    </div>

    <div *ngIf="showAllOrders" class="customer-summary">
      <p><strong>Showing All Orders</strong> </p>
    </div>

<!-- All Orders --> 
<div class="table-container" *ngIf="showAllOrders">
      <table class="table table-striped no-wrap">
        <thead>
          <tr>
            <th>Order ID</th>
            <th>Order Number</th>
            <th>Status</th>
            <th>Total</th>
            <th>Created</th>
            <th>Customer Email</th>
          </tr>
        </thead>

        <tbody>
  <ng-container *ngFor="let order of orders.orders">
    <!-- Order summary row -->


    <tr 
      (click)="toggleExpand(order.order_id)"
      [class.expanded]="expandedOrders.has(order.order_id)"
      class="order-row"
    >
      <td>{{ order.order_id }}</td>
      <td>{{ order.order_number }}</td>
      <td>{{ order.order_status }}</td>
      <td>{{ order.total_amount | currency: order.currency }}</td>
      <td>{{ order.created_at | date: 'short' }}</td>
      <td>{{ order.customer_email }}</td>
    </tr>

    <!-- Expanded section row (always present, just collapsed) -->
    <tr class="expand-row">
  <td colspan="6">
    <div class="expander" [class.open]="expandedOrders.has(order.order_id)">

      <div class="order-details-grid">
        <div><strong>Billing Address:</strong><br />{{ orderDetailsMap.get(order.order_id)?.order.billing_address }}</div>
        <div><strong>Shipping Address:</strong><br />{{ orderDetailsMap.get(order.order_id)?.order.shipping_address }}</div>
        <div><strong>Tax Region:</strong><br />{{ orderDetailsMap.get(order.order_id)?.order.tax_region }}</div>
        <div><strong>Tax Amount:</strong><br />{{ orderDetailsMap.get(order.order_id)?.order.tax_amount }}</div>
        <div><strong>Subtotal:</strong><br />{{ orderDetailsMap.get(order.order_id)?.order.subtotal }}</div>
        <div><strong>Currency:</strong><br />{{ orderDetailsMap.get(order.order_id)?.order.currency }}</div>
        <div><strong>Customer Name:</strong><br />{{ orderDetailsMap.get(order.order_id)?.order.customer.customer_name }}</div>
        <div><strong>Customer ID:</strong><br />{{ orderDetailsMap.get(order.order_id)?.order.customer.customer_id }}</div>
      </div>

      <table class="inner-table table table-bordered">
            <thead>
              <tr>
                <th>SKU</th>
                <th>Product</th>
                <th>Quantity</th>
                <th>Unit Price</th>
                <th>Line Total</th>
              </tr>
            </thead>
        <tbody>
          <tr *ngFor="let item of orderDetailsMap.get(order.order_id)?.order.items">
            <td>{{ item.sku }}</td>
            <td>{{ item.product_name }}</td>
            <td>{{ item.quantity }}</td>
            <td>{{ item.unit_price | currency: order.currency }}</td>
            <td>{{ item.quantity * item.unit_price | currency: order.currency }}</td>
          </tr>
        </tbody>
      </table>

    </div>
  </td>
</tr>

  </ng-container>
</tbody>

      </table>
    </div>



    <!-- CustomerOrders -->
    <div class="table-container" *ngIf="!showAllOrders">
      <table class="table table-striped no-wrap">
        <thead>
          <tr>
            <th>Order ID</th>
            <th>Order Number</th>
            <th>Status</th>
            <th>Total</th>
            <th>Created</th>
            <th>Updated</th>
          </tr>
        </thead>

        <tbody>
  <ng-container *ngFor="let order of orders.orders">
    <!-- Order summary row -->


    <tr 
      (click)="toggleExpand(order.order.order_id)"
      [class.expanded]="expandedOrders.has(order.order.order_id)"
      class="order-row"
    >
      <td>{{ order.order.order_id }}</td>
      <td>{{ order.order.order_number }}</td>
      <td>{{ order.order.order_status }}</td>
      <td>{{ order.order.total_amount | currency: order.order.currency }}</td>
      <td>{{ order.order.created_at | date: 'short' }}</td>
      <td>{{ order.order.updated_at | date: 'short' }}</td>
    </tr>

    <!-- Expanded section row (always present, just collapsed) -->
    <tr class="expand-row">
      <td colspan="6">
        <div class="expander" [class.open]="expandedOrders.has(order.order.order_id)">
          <div class="order-details-grid">
            <div><strong>Billing Address:</strong><br />{{ order.order.billing_address }}</div>
            <div><strong>Shipping Address:</strong><br />{{ order.order.shipping_address }}</div>
            <div><strong>Tax Region:</strong><br />{{ order.order.tax_region }}</div>
            <div><strong>Tax Amount:</strong><br />{{ order.order.tax_amount }}</div>
            <div><strong>Subtotal:</strong><br />{{ order.order.subtotal }}</div>
            <div><strong>Currency:</strong><br />{{ order.order.currency }}</div>
          </div>

          <table class="inner-table table table-bordered">
            <thead>
              <tr>
                <th>SKU</th>
                <th>Product</th>
                <th>Quantity</th>
                <th>Unit Price</th>
                <th>Line Total</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of order.order_items">
                <td>{{ item.sku }}</td>
                <td>{{ item.product_name }}</td>
                <td>{{ item.quantity }}</td>
                <td>{{ item.unit_price | currency: order.order.currency }}</td>
                <td>{{ item.quantity * item.unit_price | currency: order.order.currency }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </td>
    </tr>
  </ng-container>
</tbody>

      </table>
    </div>
  </div>
</div>
